// extracted by mini-css-extract-plugin
var _1 = "RequestProfileWidgetTimeTracking-modulecontent__dmXw0 WidgetContentContainer-moduleWidgetContentContainer__HxIkI";
var _2 = "RequestProfileWidgetTimeTracking-modulefield__Fkdxn";
var _3 = "RequestProfileWidgetTimeTracking-modulelabel__LsBvI";
var _4 = "RequestProfileWidgetTimeTracking-moduleskeleton__ZXa1v WidgetContentSkeleton-moduleWidgetContentSkeleton__eblVC";
var _5 = "RequestProfileWidgetTimeTracking-modulevalue__qtxcw";
export { _1 as "content", _2 as "field", _3 as "label", _4 as "skeleton", _5 as "value" }
